import ScopeIcon from "pages/farms/tasks/list/ScopeIcon";
import React, { FunctionComponent, useState } from "react";
import { useTranslation } from "react-i18next";
import farmSo from "stores/farm";
import SelectorDialogBase from "../base/SelectorDialogBase";
import Chip from "./Chip";



interface Props {
	scope?: string,
	onChange: (scope: string) => void,
	sx?: any
}

const SelectorScopeH: FunctionComponent<Props> = ({
	scope,
	onChange,
	sx,
}) => {


	// STORE

	// HOOKs
	const { t } = useTranslation()
	const [isOpen, setIsOpen] = useState(false)

	// HANDLER
	const handleClick = () => {
		setIsOpen(true)
	}
	const handleClose = (scope: string) => {
		setIsOpen(false)
		if (scope) onChange?.(scope.toLowerCase())
	}
	const handleClear = (e: React.MouseEvent) => {
		e.stopPropagation()
		setIsOpen(false)
		onChange?.(null)
	}

	// RENDER
	const scopes = Object.keys(farmSo.state.scopes ?? {}).map(s => s?.toUpperCase())
	const label = scope && scope.length > 0 ? scope.toUpperCase() : "ALL SCOPES"

	return (<>
		<Chip sx={sx}
			label={label}
			icon={<ScopeIcon scope={scope} sx={{ height: 16, width: 16 }} />}
			active={!!scope}
			onClick={handleClick}
			onClear={handleClear}
		/>
		<SelectorDialogBase
			width={"auto"}
			height={null}
			items={scopes}
			idSelect={scope}
			title={t("selector.scope.title")}
			isOpen={isOpen}
			onClose={handleClose}
		/>
	</>)
}

export default SelectorScopeH
